module.exports = __webpack_public_path__ + "static/media/search-icon.1c7fe42b.png";